
import { defineComponent } from 'vue';
import Sidebar from '@/components/Sidebar.vue';
import globalConstants from '@/shared/globalConstants';
import SidebarConfirmation from '@/components/SidebarConfirmation.vue';
import { mapGetters } from 'vuex';
import { DateTime } from 'luxon';
import NearbyTrailerResult from '@/types/NearbyTrailerResult';

export default defineComponent({
    components: {
        Sidebar,
        SidebarConfirmation,
    },
    methods: {
        routeToDashboard(): void {
            window.location.href = 'eleos://dashboard';
        },
    },
    computed: {
        ...mapGetters({
            currentTrailerReservation: 'getCurrentTrailerReservation',
            nearbyTrailerResults: 'getNearbyTrailerResults',
        }),
        returnApp(): string {
            if (
                this.$route?.params?.company ===
                globalConstants.companies.knight
            ) {
                return 'KT Mobile';
            } else {
                return 'Pointe';
            }
        },
        expirationTime(): string | undefined {
            return this.currentTrailerReservation?.expiresAt
                .toLocal()
                .toFormat('hh:mma')
                .toLowerCase();
        },
        expirationZone(): string | undefined {
            return DateTime.local().toFormat('ZZZZ');
        },
        hasMultipleParcels(): boolean {
            const reservedTrailer = this.currentTrailerReservation.trailerId;

            const [reservationCustomer] = (
                this.nearbyTrailerResults as NearbyTrailerResult[]
            ).filter((trailerResult) =>
                trailerResult.trailers.find(
                    (trailer) => trailer.id === reservedTrailer
                )
            );

            return reservationCustomer.geofenceIds.length > 1;
        },
    },
});
